var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

const SvgBallotBox = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 93,
    viewBox: "0 0 89 93",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.375 60.4046C84.375 65.743 80.0467 65.2379 74.7083 65.2379H14.2917C8.95325 65.2379 4.625 65.743 4.625 60.4046L9.45833 26.5833C10.1664 22.3542 11.875 21.75 14.2917 21.75H74.7083C77.125 21.75 79.0366 22.2527 79.5417 26.5833L84.375 60.4046Z",
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.875 39.875C69.875 40.8364 69.4931 41.7584 68.8133 42.4383C68.1334 43.1181 67.2114 43.5 66.25 43.5H22.75C21.7886 43.5 20.8666 43.1181 20.1867 42.4383C19.5069 41.7584 19.125 40.8364 19.125 39.875C19.125 38.9136 19.5069 37.9916 20.1867 37.3117C20.8666 36.6319 21.7886 36.25 22.75 36.25H66.25C67.2114 36.25 68.1334 36.6319 68.8133 37.3117C69.4931 37.9916 69.875 38.9136 69.875 39.875Z",
    fill: "#292F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4375 41.5376V7.70431C64.4375 6.42243 63.9283 5.19305 63.0219 4.28662C62.1154 3.3802 60.8861 2.87097 59.6042 2.87097H28.1875C26.9056 2.87097 25.6762 3.3802 24.7698 4.28662C23.8634 5.19305 23.3542 6.42243 23.3542 7.70431V41.5376H64.4375Z",
    fill: "#FFD983"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M84.375 60.4166C84.375 59.1348 83.8658 57.9054 82.9594 56.999C82.0529 56.0925 80.8235 55.5833 79.5417 55.5833H9.45833C8.17645 55.5833 6.94708 56.0925 6.04065 56.999C5.13422 57.9054 4.625 59.1348 4.625 60.4166V79.75C4.625 81.0319 5.13422 82.2612 6.04065 83.1677C6.94708 84.0741 8.17645 84.5833 9.45833 84.5833H79.5417C80.8235 84.5833 82.0529 84.0741 82.9594 83.1677C83.8658 82.2612 84.375 81.0319 84.375 79.75V60.4166Z",
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M33.625 55.5833V70.0833C33.625 71.3652 34.1342 72.5946 35.0407 73.501C35.9471 74.4074 37.1765 74.9166 38.4583 74.9166H50.5417C51.8235 74.9166 53.0529 74.4074 53.9593 73.501C54.8658 72.5946 55.375 71.3652 55.375 70.0833V55.5833H33.625Z",
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.375 55.5833V53.1666C55.375 51.8848 54.8658 50.6554 53.9593 49.749C53.0529 48.8425 51.8235 48.3333 50.5417 48.3333H38.4583C37.1765 48.3333 35.9471 48.8425 35.0407 49.749C34.1342 50.6554 33.625 51.8848 33.625 53.1666V55.5833H55.375ZM48.125 66.4583C48.125 67.4197 47.7431 68.3418 47.0633 69.0216C46.3834 69.7014 45.4614 70.0833 44.5 70.0833C43.5386 70.0833 42.6166 69.7014 41.9367 69.0216C41.2569 68.3418 40.875 67.4197 40.875 66.4583V64.0416C40.875 63.0802 41.2569 62.1582 41.9367 61.4784C42.6166 60.7986 43.5386 60.4166 44.5 60.4166C45.4614 60.4166 46.3834 60.7986 47.0633 61.4784C47.7431 62.1582 48.125 63.0802 48.125 64.0416V66.4583Z",
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 12.0833C59 12.4038 58.8727 12.7111 58.6461 12.9378C58.4195 13.1644 58.1121 13.2917 57.7917 13.2917H39.6667C39.3462 13.2917 39.0389 13.1644 38.8122 12.9378C38.5856 12.7111 38.4583 12.4038 38.4583 12.0833C38.4583 11.7629 38.5856 11.4555 38.8122 11.2289C39.0389 11.0023 39.3462 10.875 39.6667 10.875H57.7917C58.1121 10.875 58.4195 11.0023 58.6461 11.2289C58.8727 11.4555 59 11.7629 59 12.0833ZM59 21.75C59 22.0705 58.8727 22.3778 58.6461 22.6044C58.4195 22.831 58.1121 22.9583 57.7917 22.9583H39.6667C39.3462 22.9583 39.0389 22.831 38.8122 22.6044C38.5856 22.3778 38.4583 22.0705 38.4583 21.75C38.4583 21.4295 38.5856 21.1222 38.8122 20.8956C39.0389 20.669 39.3462 20.5417 39.6667 20.5417H57.7917C58.1121 20.5417 58.4195 20.669 58.6461 20.8956C58.8727 21.1222 59 21.4295 59 21.75ZM59 31.4167C59 31.7371 58.8727 32.0445 58.6461 32.2711C58.4195 32.4977 58.1121 32.625 57.7917 32.625H39.6667C39.3462 32.625 39.0389 32.4977 38.8122 32.2711C38.5856 32.0445 38.4583 31.7371 38.4583 31.4167C38.4583 31.0962 38.5856 30.7889 38.8122 30.5622C39.0389 30.3356 39.3462 30.2083 39.6667 30.2083H57.7917C58.1121 30.2083 58.4195 30.3356 58.6461 30.5622C58.8727 30.7889 59 31.0962 59 31.4167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4167 14.5C33.7514 14.5 34.8333 13.418 34.8333 12.0834C34.8333 10.7487 33.7514 9.66669 32.4167 9.66669C31.082 9.66669 30 10.7487 30 12.0834C30 13.418 31.082 14.5 32.4167 14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4167 24.1667C33.7514 24.1667 34.8333 23.0847 34.8333 21.75C34.8333 20.4154 33.7514 19.3334 32.4167 19.3334C31.082 19.3334 30 20.4154 30 21.75C30 23.0847 31.082 24.1667 32.4167 24.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4167 33.8333C33.7514 33.8333 34.8333 32.7514 34.8333 31.4167C34.8333 30.082 33.7514 29 32.4167 29C31.082 29 30 30.082 30 31.4167C30 32.7514 31.082 33.8333 32.4167 33.8333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_98",
    x: -3,
    y: 0,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_98"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_98",
    result: "shape"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBallotBox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ballot-box.ac7542c2.svg";
export { ForwardRef as ReactComponent };